import { Navigate } from "react-router-dom";
import { decodeToken, isExpired } from "./token";

export default function PrivateRoute({ children }) {
  const token = localStorage.getItem("authToken");

  // No token → login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Expired token → logout + login
  if (isExpired(token)) {
    localStorage.removeItem("authToken");
    return <Navigate to="/login" replace />;
  }

  const payload = decodeToken(token);

  // Email not verified
  if (payload?.email_verified === false) {
    return <Navigate to="/verify-email" replace />;
  }

  // 2FA required
  if (payload?.two_factor_required === true) {
    return <Navigate to="/two-factor" replace />;
  }

  // All good → allow access
  return children;
}
